/**
 * EnvironmentAnnouncement — brief overlay shown when the player enters a new biome.
 * Triggered from App.js after the tier-boss chest is collected.
 * CSS handles the fade-in/hold/fade-out via animation; React state clears it after 3.5 s.
 */

const ENV_INFO = {
  forest:    { icon: '🌲', name: 'Ancient Forest',   color: '#7abf50' },
  desert:    { icon: '☀️', name: 'Scorched Desert',  color: '#e8b84a' },
  snow:      { icon: '❄️', name: 'Frozen Tundra',    color: '#c0d8e8' },
  castle:    { icon: '🏰', name: 'Ruined Fortress',  color: '#a0a0b8' },
  water:     { icon: '🌊', name: 'Sunken Depths',    color: '#40a8e0' },
  graveyard: { icon: '💀', name: 'Cursed Graveyard', color: '#8080a0' },
  inferno:   { icon: '🔥', name: 'The Inferno',      color: '#e06030' },
};

export function EnvironmentAnnouncement({ env }) {
  if (!env) return null;
  const info = ENV_INFO[env] ?? ENV_INFO.forest;

  return (
    <div className="env-announcement" key={env}>
      <div className="env-announcement__icon">{info.icon}</div>
      <div className="env-announcement__entering">ENTERING</div>
      <div className="env-announcement__name" style={{ color: info.color }}>
        {info.name}
      </div>
    </div>
  );
}
